export default "__VITE_ASSET__CAG7APKY__"